import { StyledLink } from './LevelSelector.styled'
import React, { useContext } from 'react'
import { courseStore } from '../../state/courseStore'
import { withRouter } from 'react-router-dom'
import { FormattedHTMLMessage } from 'react-intl'
import Image from '../Image'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheckCircle } from '@fortawesome/free-regular-svg-icons'
const LevelLinks = ({ levels, history }) => {
  const { dispatch } = useContext(courseStore)
  const startCourse = (levelID, pageID) => {
    dispatch({ type: 'next-module-page', levelID, pageID })
    history.push(`/${levelID}/${pageID}`)
  }
  const linkVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: { opacity: 1, y: 0 }
  }

  return (
    <>
      {levels.map((level, index) =>
        <StyledLink
          variants={linkVariants}
          key={index}
          onClick={() => startCourse(level.id, level.lastpage)}
          level={level}
          tabIndex={(index + 1) * 10}
          className={level.completed ? 'completed' : ''}
        >
          <FormattedHTMLMessage id={level.id + '.navTitle'} />
          {level.completed && <FontAwesomeIcon icon={faCheckCircle} size='2x' />}
          <Image src={`levelmenu/${level.id}.png`} height='12.5rem' width='10rem' />
        </StyledLink>
      )}
    </>
  )
}

export default withRouter(LevelLinks)
